/**
 * NumberIcon/index.js
 * desc: number data-type icon
 * note: type icon via IconButton; defaults its tooltip + accessible name to the
 *       data-type title. Exported as both the default and a named (ref-able) component.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


export const NumberIcon = ({ tooltip, ref, ...props }) => {
    return (
        <IconButton ref={ ref } baseClassName="number icon" label={ tooltip || translate('icons.number.tooltip.text') } tooltip={ tooltip } { ...props }>
            <svg viewBox="0 0 10 9" xmlns="http://www.w3.org/2000/svg"><path d="M1.531 8.063a.677.677 0 0 1-.496-.208.677.677 0 0 1-.207-.496c0-.192.07-.358.207-.496a.677.677 0 0 1 .496-.207c.193 0 .358.07.496.207a.677.677 0 0 1 .207.496.73.73 0 0 1-.352.61.67.67 0 0 1-.35.093ZM6.873 8l1.313-8h.78L7.655 8h-.78Zm-3.64-2.219L3.356 5h5.97l-.126.781H3.232ZM4.06 8l1.312-8h.781L4.842 8H4.06ZM3.7 3l.125-.781h5.969L9.67 3H3.7Z"/></svg>
        </IconButton>
    );
};


export default NumberIcon;
